import { Base } from '../core/base.model';
import { FetchResult } from '../emision/FetchResult.model';

export class Sitios {

    public id: number;
    public nombre: string;
    //public fetch: FetchResult<Sitios> = new FetchResult<Sitios>();

}